import { put, call, fork, takeLatest, takeEvery } from 'redux-saga/effects';
import {
  GET_PRODUCT_SELECTION_LIST,
  GET_NEW_ADDONS_LIST
} from '../actionTypes';
import {
  PRODUCT_SELECTION_API,
  NEW_GET_ADDONS_LIST_API
} from '../../constants/api-constants';

import * as API from '../../utils/ajax';
import * as Actions from './actions';

function* getProductSelectionAsync(action) {
  try {
    const { payload } = action;
    const { product_id, outlet_id, ...rest } = payload;
    const response = yield call(API.post, PRODUCT_SELECTION_API, {
      ...rest,
      outlet_id
    });
    if (response.error === 0) {
      if (
        Array.isArray(response?.content) &&
        !!response?.content[0] &&
        !!response?.content[0].variant_category &&
        Array.isArray(response?.content[0].variant_category.variants)
      ) {
        yield put(
          Actions.getProductionSelectionListSuccess(response.content[0], action)
        );
      } else {
        throw Error('Something went wrong');
      }
    } else {
      yield put(
        Actions.getProductionSelectionListError(response.error, action)
      );
    }
  } catch (error) {
    yield put(Actions.getProductionSelectionListError(error, action));
  }
}

function* getNewAddonsListAsync(action) {
  try {
    const response = yield call(
      API.post,
      NEW_GET_ADDONS_LIST_API,
      action.payload
    );
    if (response.error === 0 && !!response?.content) {
      yield put(Actions.getNewAddonsListSuccess(response.content,action));
    } else {
      throw Error('Something went wrong when fetching the addons');
    }
  } catch (error) {
    yield put(Actions.getNewAddonsListError(error, action));
  }
}

export function* watchProductSelectionSaga() {
  yield takeLatest(GET_PRODUCT_SELECTION_LIST, getProductSelectionAsync);
  yield takeLatest(GET_NEW_ADDONS_LIST, getNewAddonsListAsync);
}

const productSelectionSaga = [fork(watchProductSelectionSaga)];
export default productSelectionSaga;
